import { headerHeights } from "../components/shared/config";

export const calculateHeaderHeights = {
  getLogoContainerHeight(isScreenXs, appStarted) {
    const { logoContainerHeightForCalculation } = headerHeights();

    const logoContainerDefaultHeight = isScreenXs
      ? logoContainerHeightForCalculation.mobile
      : logoContainerHeightForCalculation.desktop;

    const currentContainerHeight = appStarted ? logoContainerDefaultHeight : 0;

    return currentContainerHeight;
  },
  getSectionsHeight(isScreenXs, currentSection, sectionsArray, appStarted) {
    const { progressBarForCalculation } = headerHeights();
    const progressBarDefaultHeight = isScreenXs
      ? progressBarForCalculation.mobile
      : progressBarForCalculation.desktop;
    const isSectionAvailable = currentSection && sectionsArray && appStarted;

    const currentProgressBarHeight = isSectionAvailable
      ? progressBarDefaultHeight
      : 0;
    return currentProgressBarHeight;
  },
};
